import ViewBase from "../../../framework/core/mvvm/view_base";
import LanguageManager from "../../../manager/language_manager";
import GameUtil from "../../../utility/game_util";
import { CountUp } from "../../../lib/countUp";
import Utility from "../../../utility/utility";
import { ClubNoticeEvent } from "./clubnotice_event";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ClubNoticeView extends ViewBase {

    @property(cc.Node)
    marqueeNode: cc.Node = null

    @property(cc.Node)
    centerNode: cc.Node = null

    @property(cc.Label)
    marqeeLabel: cc.Label = null

    @property(cc.RichText)
    noticeLabel: cc.RichText = null

    @property(cc.Node)
    noticeEditBtn: cc.Node = null

    @property(cc.Node)
    cancelEditBtn: cc.Node = null

    @property(cc.Node)
    sureEditBtn: cc.Node = null

    @property(cc.Node)
    seeEditBtn: cc.Node = null

    @property(cc.Node)
    noticeScrollNode: cc.Node = null

    @property(cc.EditBox)
    noticeEditInput: cc.EditBox = null

    @property(ClubNoticeEvent)
    noticeEvent:ClubNoticeEvent = null

noticeContent:string
noticeContent2:string

    onShow() {
        // this.marqueeNode.active = false
        // this.centerNode.active = false
    }


    showNotice(show, str?, canEdit?) {
        if (show == 0) {
            this.showMarquee(str)
        } else if (show == 1) {
            if (str == undefined){
                str = ""
            }
            this.showCenter(str, canEdit)
        } else {
            this.showCenter()
        }
    }

    showMarquee(str) {
        let self = this
        // this.centerNode.active = false
        if(str == undefined){
            this.marqueeNode.active = false
            return
        }
        this.noticeContent2 = str
        str = str.replace(/[\r\n]/g,"");  
        str = str.replace(/<\/?.+?>/g, "");
        if(str.length > 60){
            str = str.substr(0,60) + "..."
        }
        this.noticeContent = str
        this.marqeeLabel.string = str
        this.marqueeNode.opacity = 0
        this.marqueeNode.active = true
        this.marqeeLabel.node.x = this.marqueeNode.width / 2
        this.marqueeNode.stopAllActions()
        this.marqueeNode.runAction(cc.sequence([cc.fadeIn(0.2),cc.callFunc(function(){
            self.startMarquee()
        }.bind(self))]))
    }
    startMarquee() {
        let self = this
        this.marqeeLabel.node.stopAllActions()
        let x = -(this.marqueeNode.width / 2 + this.marqeeLabel.node.width)
        this.marqeeLabel.node.x = this.marqueeNode.width / 2
        this.marqeeLabel.string = this.noticeContent
        //@ts-ignore
        this.marqeeLabel._forceUpdateRenderData(true)
        let distance = this.marqeeLabel.node.width + this.marqueeNode.width
        let t = 8 / this.marqueeNode.width * distance
        this.marqeeLabel.node.runAction(cc.sequence([cc.moveTo(t, new cc.Vec2(x, 0)), cc.callFunc(function () {
            self.startMarquee()
        })]))
    }

    showCenter(str?, canEdit?) {
        if (str == undefined) {
            let self = this
            this.centerNode.runAction(cc.sequence([cc.fadeOut(0.2), cc.callFunc(function () {
                self.centerNode.active = false
            }.bind(self))]))
        } else {
            this.noticeScrollNode.active = true
            this.noticeFunc(true)
            this.noticeEditInput.node.active = false
            this.noticeLabel.string = str
            this.centerNode.opacity = 0
            this.centerNode.active = true
            this.centerNode.runAction(cc.fadeIn(0.2))
            this.noticeEditBtn.active = canEdit
        }
    }
    noticeChange(content){
        this.showMarquee(content)
        if(this.centerNode.active){
            this.noticeLabel = content
        }
    }

    noticeEdit() {
        this.noticeFunc(false)
        this.noticeScrollNode.active = false
        this.noticeEditInput.string = this.noticeLabel.string
        this.noticeEditInput.node.active = true
        this.noticeEditInput.focus()
    }

    seeNotice(){

    }
    noticeEditEnd(suc) {
        this.noticeFunc(true)
        if(suc){
            this.noticeLabel.string = this.noticeEditInput.string
        }else{
            this.noticeLabel.string = this.noticeContent2
        }
        this.noticeScrollNode.active = true
       
        this.noticeEditInput.node.active = false
    }

    noticeFunc(open){
        this.noticeEditBtn.active = open
        this.cancelEditBtn.active = !open
        this.sureEditBtn.active = !open
        this.seeEditBtn.active = !open
    }
    onHide(){
        this.marqeeLabel.node.stopAllActions()
    }
}
